<template>
  <div style="margin-top: 20px">
    <div ref="chartContainer" style="width: 100%; height: 600px;;margin-bottom: 50px" />
  </div>
</template>
<script>
import echarts from 'echarts'

export default {
  name: 'TodayEchart',
  props: {
    title: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#6495ED'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.title
        },
        xAxis: {
          name: '类型',
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0, // 显示所有刻度标签,
            rotate: 45 // 将标签旋转90度
          }
        },
        legend: {
          data: [],
          orient: 'horizontal', // 图例水平显示
          bottom: 0, // 图例在图表的底部
          left: 'center', // 图例居中对齐
          itemGap: 20, // 图例项之间的间距
          textStyle: {
            fontSize: 12
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: 100,
          containLabel: true
        },
        yAxis: [
          {
            type: 'value',
            name: '总计',
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '占比',
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        toolbox: {
          show: true
        },
        tooltip: {
          trigger: 'axis',
          position: function(point) {
            const x = point[0]
            const y = '5%'// 向下移动 20 像素
            return [x, y]
          }
        },
        series: [
          {
            name: '总计',
            type: 'bar',
            data: [],
            barWidth: '50%',
            itemStyle: {
              normal: {
                color: this.color
              }
            }
          },
          {
            name: '占比',
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: '#FF0000'
              }
            },
            tooltip: {
              trigger: 'axis',
              valueFormatter: function(value) {
                return value + ' %'
              }
            },
            data: []
          },
          {
            name: '自然占比',
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: '#FA8072'
              }
            },
            tooltip: {
              valueFormatter: function(value) {
                return value + ' %'
              }
            },
            data: []
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    init(data) {
      this.option.xAxis.data = []
      this.option.series[0].date = []
      this.option.series[1].date = []
      this.option.legend.data = []
      const lenged = []
      const date = []
      const d = []
      const rate = []

      data.forEach((item) => {
        lenged.push(item.type)
        date.push(item.type)
        d.push(item.num)
        rate.push(item.rate)
      })

      this.option.xAxis.data = date
      this.option.series[0].data = d
      this.option.series[1].data = rate
      this.option.legend.data = lenged
      this.chart.setOption(this.option, true)
    }
  }
}
</script>

<style scoped>

</style>
